
import OmegaSquare from "../../../assets/filled/OmegaSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function OmegaSquareIcon({ className, dataTestid = "OmegaSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <OmegaSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
